import React from 'react';
import PropTypes from 'prop-types';
import { Button, Row, Col, Spinner } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import Input from 'components/common/Input';

const ChangePassword = ({ onSubmitData, onError, isLoading }) => {
 const {
  watch,
  register,
  handleSubmit,
  formState: { errors }
 } = useForm({ defaultValues: {} });

 return (
  <>
   <Row className="flex-between-center g-3 mb-4">
    <Input
     type="text"
     label="Contraseña anterior*"
     name="oldPassword"
     errors={errors}
     placeholder="Old Password"
     formLabelProps={{ className: 'mb-0 fs--1' }}
     formGroupProps={{ as: Col, sm: 12 }}
     formControlProps={{
      ...register('oldPassword', { required: true }),
      autoComplete: 'off'
     }}
    />
    <Input
     type="text"
     label="Nueva contraseña*"
     name="newPassword"
     errors={errors}
     placeholder="New Password"
     formLabelProps={{ className: 'mb-0 fs--1' }}
     formGroupProps={{ as: Col, sm: 12 }}
     formControlProps={{
      ...register('newPassword', { required: true, minLength: { value: 8, message: 'Debe tener minimo 8 caracteres' } }),
      autoComplete: 'off'
     }}
    />
    <Input
     type="text"
     label="Confirmar Contraseña*"
     name="confirmPassword"
     errors={errors}
     placeholder="Confirm Password"
     formLabelProps={{ className: 'mb-0 fs--1' }}
     formGroupProps={{ as: Col, sm: 12 }}
     formControlProps={{
      ...register('confirmPassword', {
       required: true,
       validate: val => watch('newPassword') === val || 'Las contraseña no coinsiden',
       minLength: { value: 8, message: 'Debe tener minimo 8 caracteres' }
      }),
      autoComplete: 'off'
     }}
    />
   </Row>

   {isLoading && <Spinner animation="border" variant="primary" className="ms-md-3 my-auto float-start" />}

   <Button className="w-100" onClick={() => handleSubmit(onSubmitData, onError)()}>
    Update Password
   </Button>
  </>
 );
};

ChangePassword.propTypes = {
 onSubmitData: PropTypes.func,
 onError: PropTypes.func,
 isLoading: PropTypes.bool
};

export default ChangePassword;
